import { render, staticRenderFns } from "./LandlordAddPM.vue?vue&type=template&id=98ed90d8&scoped=true&"
import script from "./LandlordAddPM.vue?vue&type=script&lang=js&"
export * from "./LandlordAddPM.vue?vue&type=script&lang=js&"
import style0 from "./LandlordAddPM.vue?vue&type=style&index=0&id=98ed90d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ed90d8",
  null
  
)

export default component.exports